const Laenderliste = (limitTo = false) => {

    if (limitTo == "eu") {
        return euLaender();
    }

    return laender;
} 

const laender = [
    {id:4,label:"Afghanistan",code:"af",alpha3:"afg"},
    {id:818,label:"Ägypten",code:"eg",alpha3:"egy"},
    {id:248,label:"Åland",code:"ax",alpha3:"ala", eu:true},
    {id:8,label:"Albanien",code:"al",alpha3:"alb"},
    {id:12,label:"Algerien",code:"dz",alpha3:"dza"},
    {id:16,label:"Amerikanisch-Samoa",code:"as",alpha3:"asm"},
    {id:850,label:"Amerikanische Jungferninseln",code:"vi",alpha3:"vir"},
    {id:20,label:"Andorra",code:"ad",alpha3:"and"},
    {id:24,label:"Angola",code:"ao",alpha3:"ago"},
    {id:660,label:"Anguilla",code:"ai",alpha3:"aia"},
    {id:10,label:"Antarktis (Sonderstatus durch Antarktisvertrag)",code:"aq",alpha3:"ata"},
    {id:28,label:"Antigua und Barbuda",code:"ag",alpha3:"atg"},
    {id:226,label:"Äquatorialguinea",code:"gq",alpha3:"gnq"},
    {id:32,label:"Argentinien",code:"ar",alpha3:"arg"},
    {id:51,label:"Armenien",code:"am",alpha3:"arm"},
    {id:533,label:"Aruba",code:"aw",alpha3:"abw"},
    {id:31,label:"Aserbaidschan",code:"az",alpha3:"aze"},
    {id:231,label:"Äthiopien",code:"et",alpha3:"eth"},
    {id:36,label:"Australien",code:"au",alpha3:"aus"},
    {id:44,label:"Bahamas",code:"bs",alpha3:"bhs"},
    {id:48,label:"Bahrain",code:"bh",alpha3:"bhr"},
    {id:50,label:"Bangladesch",code:"bd",alpha3:"bgd"},
    {id:52,label:"Barbados",code:"bb",alpha3:"brb"},
    {id:112,label:"Belarus",code:"by",alpha3:"blr"},
    {id:56,label:"Belgien",code:"be",alpha3:"bel", eu:true},
    {id:84,label:"Belize",code:"bz",alpha3:"blz"},
    {id:204,label:"Benin",code:"bj",alpha3:"ben"},
    {id:60,label:"Bermuda",code:"bm",alpha3:"bmu"},
    {id:64,label:"Bhutan",code:"bt",alpha3:"btn"},
    {id:68,label:"Bolivien",code:"bo",alpha3:"bol"},
    {id:535,label:"Bonaire, Saba, Sint Eustatius",code:"bq",alpha3:"bes"},
    {id:70,label:"Bosnien und Herzegowina",code:"ba",alpha3:"bih"},
    {id:72,label:"Botswana",code:"bw",alpha3:"bwa"},
    {id:74,label:"Bouvetinsel",code:"bv",alpha3:"bvt"},
    {id:76,label:"Brasilien",code:"br",alpha3:"bra"},
    {id:92,label:"Britische Jungferninseln",code:"vg",alpha3:"vgb"},
    {id:86,label:"Britisches Territorium im Indischen Ozean",code:"io",alpha3:"iot"},
    {id:96,label:"Brunei",code:"bn",alpha3:"brn"},
    {id:100,label:"Bulgarien",code:"bg",alpha3:"bgr", eu:true},
    {id:854,label:"Burkina Faso",code:"bf",alpha3:"bfa"},
    {id:108,label:"Burundi",code:"bi",alpha3:"bdi"},
    {id:152,label:"Chile",code:"cl",alpha3:"chl"},
    {id:156,label:"Volksrepublik China",code:"cn",alpha3:"chn"},
    {id:184,label:"Cookinseln",code:"ck",alpha3:"cok"},
    {id:188,label:"Costa Rica",code:"cr",alpha3:"cri"},
    {id:531,label:"Curaçao",code:"cw",alpha3:"cuw"},
    {id:208,label:"Dänemark",code:"dk",alpha3:"dnk", eu:true},
    {id:276,label:"Deutschland",code:"de",alpha3:"deu", eu:true, de:true},
    {id:212,label:"Dominica",code:"dm",alpha3:"dma"},
    {id:214,label:"Dominikanische Republik",code:"do",alpha3:"dom"},
    {id:262,label:"Dschibuti",code:"dj",alpha3:"dji"},
    {id:218,label:"Ecuador",code:"ec",alpha3:"ecu"},
    {id:384,label:"Elfenbeinküste",code:"ci",alpha3:"civ"},
    {id:222,label:"El Salvador",code:"sv",alpha3:"slv"},
    {id:232,label:"Eritrea",code:"er",alpha3:"eri"},
    {id:233,label:"Estland",code:"ee",alpha3:"est", eu:true},
    {id:748,label:"Eswatini",code:"sz",alpha3:"swz"},
    {id:238,label:"Falklandinseln",code:"fk",alpha3:"flk"},
    {id:234,label:"Färöer",code:"fo",alpha3:"fro"},
    {id:242,label:"Fidschi",code:"fj",alpha3:"fji"},
    {id:246,label:"Finnland",code:"fi",alpha3:"fin", eu:true},
    {id:250,label:"Frankreich",code:"fr",alpha3:"fra", eu:true},
    {id:254,label:"Französisch-Guayana",code:"gf",alpha3:"guf", eu:true},
    {id:258,label:"Französisch-Polynesien",code:"pf",alpha3:"pyf"},
    {id:260,label:"Französische Süd- und Antarktisgebiete",code:"tf",alpha3:"atf"},
    {id:266,label:"Gabun",code:"ga",alpha3:"gab"},
    {id:270,label:"Gambia",code:"gm",alpha3:"gmb"},
    {id:268,label:"Georgien",code:"ge",alpha3:"geo"},
    {id:288,label:"Ghana",code:"gh",alpha3:"gha"},
    {id:292,label:"Gibraltar",code:"gi",alpha3:"gib"},
    {id:308,label:"Grenada",code:"gd",alpha3:"grd"},
    {id:300,label:"Griechenland",code:"gr",alpha3:"grc", eu:true},
    {id:304,label:"Grönland",code:"gl",alpha3:"grl"},
    {id:312,label:"Guadeloupe",code:"gp",alpha3:"glp", eu:true},
    {id:316,label:"Guam",code:"gu",alpha3:"gum"},
    {id:320,label:"Guatemala",code:"gt",alpha3:"gtm"},
    {id:831,label:"Guernsey (Kanalinsel)",code:"gg",alpha3:"ggy"},
    {id:324,label:"Guinea",code:"gn",alpha3:"gin"},
    {id:624,label:"Guinea-Bissau",code:"gw",alpha3:"gnb"},
    {id:328,label:"Guyana",code:"gy",alpha3:"guy"},
    {id:332,label:"Haiti",code:"ht",alpha3:"hti"},
    {id:334,label:"Heard und McDonaldinseln",code:"hm",alpha3:"hmd"},
    {id:340,label:"Honduras",code:"hn",alpha3:"hnd"},
    {id:344,label:"Hongkong",code:"hk",alpha3:"hkg"},
    {id:356,label:"Indien",code:"in",alpha3:"ind"},
    {id:360,label:"Indonesien",code:"id",alpha3:"idn"},
    {id:833,label:"Insel Man",code:"im",alpha3:"imn"},
    {id:368,label:"Irak",code:"iq",alpha3:"irq"},
    {id:364,label:"Iran",code:"ir",alpha3:"irn"},
    {id:372,label:"Irland",code:"ie",alpha3:"irl", eu:true},
    {id:352,label:"Island",code:"is",alpha3:"isl"},
    {id:376,label:"Israel",code:"il",alpha3:"isr"},
    {id:380,label:"Italien",code:"it",alpha3:"ita", eu:true},
    {id:388,label:"Jamaika",code:"jm",alpha3:"jam"},
    {id:392,label:"Japan",code:"jp",alpha3:"jpn"},
    {id:887,label:"Jemen",code:"ye",alpha3:"yem"},
    {id:832,label:"Jersey (Kanalinsel)",code:"je",alpha3:"jey"},
    {id:400,label:"Jordanien",code:"jo",alpha3:"jor"},
    {id:136,label:"Kaimaninseln",code:"ky",alpha3:"cym"},
    {id:116,label:"Kambodscha",code:"kh",alpha3:"khm"},
    {id:120,label:"Kamerun",code:"cm",alpha3:"cmr"},
    {id:124,label:"Kanada",code:"ca",alpha3:"can"},
    {id:132,label:"Kap Verde",code:"cv",alpha3:"cpv"},
    {id:398,label:"Kasachstan",code:"kz",alpha3:"kaz"},
    {id:634,label:"Katar",code:"qa",alpha3:"qat"},
    {id:404,label:"Kenia",code:"ke",alpha3:"ken"},
    {id:417,label:"Kirgisistan",code:"kg",alpha3:"kgz"},
    {id:296,label:"Kiribati",code:"ki",alpha3:"kir"},
    {id:166,label:"Kokosinseln",code:"cc",alpha3:"cck"},
    {id:170,label:"Kolumbien",code:"co",alpha3:"col"},
    {id:174,label:"Komoren",code:"km",alpha3:"com"},
    {id:180,label:"Kongo, Demokratische Republik",code:"cd",alpha3:"cod"},
    {id:178,label:"Kongo, Republik",code:"cg",alpha3:"cog"},
    {id:408,label:"Korea, Nord",code:"kp",alpha3:"prk"},
    {id:410,label:"Korea, Süd",code:"kr",alpha3:"kor"},
    {id:191,label:"Kroatien",code:"hr",alpha3:"hrv", eu:true},
    {id:192,label:"Kuba",code:"cu",alpha3:"cub"},
    {id:414,label:"Kuwait",code:"kw",alpha3:"kwt"},
    {id:418,label:"Laos",code:"la",alpha3:"lao"},
    {id:426,label:"Lesotho",code:"ls",alpha3:"lso"},
    {id:428,label:"Lettland",code:"lv",alpha3:"lva", eu:true},
    {id:422,label:"Libanon",code:"lb",alpha3:"lbn"},
    {id:430,label:"Liberia",code:"lr",alpha3:"lbr"},
    {id:434,label:"Libyen",code:"ly",alpha3:"lby"},
    {id:438,label:"Liechtenstein",code:"li",alpha3:"lie"},
    {id:440,label:"Litauen",code:"lt",alpha3:"ltu", eu:true},
    {id:442,label:"Luxemburg",code:"lu",alpha3:"lux", eu:true},
    {id:446,label:"Macau",code:"mo",alpha3:"mac"},
    {id:450,label:"Madagaskar",code:"mg",alpha3:"mdg"},
    {id:454,label:"Malawi",code:"mw",alpha3:"mwi"},
    {id:458,label:"Malaysia",code:"my",alpha3:"mys"},
    {id:462,label:"Malediven",code:"mv",alpha3:"mdv"},
    {id:466,label:"Mali",code:"ml",alpha3:"mli"},
    {id:470,label:"Malta",code:"mt",alpha3:"mlt"},
    {id:504,label:"Marokko",code:"ma",alpha3:"mar"},
    {id:584,label:"Marshallinseln",code:"mh",alpha3:"mhl"},
    {id:474,label:"Martinique",code:"mq",alpha3:"mtq", eu:true},
    {id:478,label:"Mauretanien",code:"mr",alpha3:"mrt"},
    {id:480,label:"Mauritius",code:"mu",alpha3:"mus"},
    {id:175,label:"Mayotte",code:"yt",alpha3:"myt", eu:true},
    {id:484,label:"Mexiko",code:"mx",alpha3:"mex"},
    {id:583,label:"Mikronesien",code:"fm",alpha3:"fsm"},
    {id:498,label:"Moldau",code:"md",alpha3:"mda"},
    {id:492,label:"Monaco",code:"mc",alpha3:"mco"},
    {id:496,label:"Mongolei",code:"mn",alpha3:"mng"},
    {id:499,label:"Montenegro",code:"me",alpha3:"mne"},
    {id:500,label:"Montserrat",code:"ms",alpha3:"msr"},
    {id:508,label:"Mosambik",code:"mz",alpha3:"moz"},
    {id:104,label:"Myanmar",code:"mm",alpha3:"mmr"},
    {id:516,label:"Namibia",code:"na",alpha3:"nam"},
    {id:520,label:"Nauru",code:"nr",alpha3:"nru"},
    {id:524,label:"Nepal",code:"np",alpha3:"npl"},
    {id:540,label:"Neukaledonien",code:"nc",alpha3:"ncl"},
    {id:554,label:"Neuseeland",code:"nz",alpha3:"nzl"},
    {id:558,label:"Nicaragua",code:"ni",alpha3:"nic"},
    {id:528,label:"Niederlande",code:"nl",alpha3:"nld", eu:true},
    {id:562,label:"Niger",code:"ne",alpha3:"ner"},
    {id:566,label:"Nigeria",code:"ng",alpha3:"nga"},
    {id:570,label:"Niue",code:"nu",alpha3:"niu"},
    {id:580,label:"Nördliche Marianen",code:"mp",alpha3:"mnp"},
    {id:807,label:"Nordmazedonien",code:"mk",alpha3:"mkd"},
    {id:574,label:"Norfolkinsel",code:"nf",alpha3:"nfk"},
    {id:578,label:"Norwegen",code:"no",alpha3:"nor"},
    {id:512,label:"Oman",code:"om",alpha3:"omn"},
    {id:40,label:"Österreich",code:"at",alpha3:"aut", eu:true},
    {id:626,label:"Osttimor",code:"tl",alpha3:"tls"},
    {id:586,label:"Pakistan",code:"pk",alpha3:"pak"},
    {id:275,label:"Palästina",code:"ps",alpha3:"pse"},
    {id:585,label:"Palau",code:"pw",alpha3:"plw"},
    {id:591,label:"Panama",code:"pa",alpha3:"pan"},
    {id:598,label:"Papua-Neuguinea",code:"pg",alpha3:"png"},
    {id:600,label:"Paraguay",code:"py",alpha3:"pry"},
    {id:604,label:"Peru",code:"pe",alpha3:"per"},
    {id:608,label:"Philippinen",code:"ph",alpha3:"phl"},
    {id:612,label:"Pitcairninseln",code:"pn",alpha3:"pcn"},
    {id:616,label:"Polen",code:"pl",alpha3:"pol", eu:true},
    {id:620,label:"Portugal",code:"pt",alpha3:"prt", eu:true},
    {id:630,label:"Puerto Rico",code:"pr",alpha3:"pri"},
    {id:638,label:"Réunion",code:"re",alpha3:"reu", eu:true},
    {id:646,label:"Ruanda",code:"rw",alpha3:"rwa"},
    {id:642,label:"Rumänien",code:"ro",alpha3:"rou", eu:true},
    {id:643,label:"Russland",code:"ru",alpha3:"rus"},
    {id:90,label:"Salomonen",code:"sb",alpha3:"slb"},
    {id:652,label:"Saint-Barthélemy",code:"bl",alpha3:"blm", eu:true},
    {id:663,label:"Saint-Martin (französischer Teil)",code:"mf",alpha3:"maf", eu:true},
    {id:894,label:"Sambia",code:"zm",alpha3:"zmb"},
    {id:882,label:"Samoa",code:"ws",alpha3:"wsm"},
    {id:674,label:"San Marino",code:"sm",alpha3:"smr"},
    {id:678,label:"São Tomé und Príncipe",code:"st",alpha3:"stp"},
    {id:682,label:"Saudi-Arabien",code:"sa",alpha3:"sau"},
    {id:752,label:"Schweden",code:"se",alpha3:"swe", eu:true},
    {id:756,label:"Schweiz",code:"ch",alpha3:"che"},
    {id:686,label:"Senegal",code:"sn",alpha3:"sen"},
    {id:688,label:"Serbien",code:"rs",alpha3:"srb"},
    {id:690,label:"Seychellen",code:"sc",alpha3:"syc"},
    {id:694,label:"Sierra Leone",code:"sl",alpha3:"sle"},
    {id:716,label:"Simbabwe",code:"zw",alpha3:"zwe"},
    {id:702,label:"Singapur",code:"sg",alpha3:"sgp"},
    {id:534,label:"Sint Maarten",code:"sx",alpha3:"sxm"},
    {id:703,label:"Slowakei",code:"sk",alpha3:"svk", eu:true},
    {id:705,label:"Slowenien",code:"si",alpha3:"svn", eu:true},
    {id:706,label:"Somalia",code:"so",alpha3:"som"},
    {id:724,label:"Spanien",code:"es",alpha3:"esp", eu:true},
    {id:144,label:"Sri Lanka",code:"lk",alpha3:"lka"},
    {id:654,label:"St. Helena, Ascension und Tristan da Cunha",code:"sh",alpha3:"shn"},
    {id:659,label:"St. Kitts und Nevis",code:"kn",alpha3:"kna"},
    {id:662,label:"St. Lucia",code:"lc",alpha3:"lca"},
    {id:666,label:"Saint-Pierre und Miquelon",code:"pm",alpha3:"spm"},
    {id:670,label:"St. Vincent und die Grenadinen",code:"vc",alpha3:"vct"},
    {id:710,label:"Südafrika",code:"za",alpha3:"zaf"},
    {id:729,label:"Sudan",code:"sd",alpha3:"sdn"},
    {id:239,label:"Südgeorgien und die Südlichen Sandwichinseln",code:"gs",alpha3:"sgs"},
    {id:728,label:"Südsudan",code:"ss",alpha3:"ssd"},
    {id:740,label:"Suriname",code:"sr",alpha3:"sur"},
    {id:744,label:"Spitzbergen und Jan Mayen",code:"sj",alpha3:"sjm"},
    {id:760,label:"Syrien",code:"sy",alpha3:"syr"},
    {id:762,label:"Tadschikistan",code:"tj",alpha3:"tjk"},
    {id:158,label:"Republik China",code:"tw",alpha3:"twn"},
    {id:834,label:"Tansania",code:"tz",alpha3:"tza"},
    {id:764,label:"Thailand",code:"th",alpha3:"tha"},
    {id:768,label:"Togo",code:"tg",alpha3:"tgo"},
    {id:772,label:"Tokelau",code:"tk",alpha3:"tkl"},
    {id:776,label:"Tonga",code:"to",alpha3:"ton"},
    {id:780,label:"Trinidad und Tobago",code:"tt",alpha3:"tto"},
    {id:148,label:"Tschad",code:"td",alpha3:"tcd"},
    {id:203,label:"Tschechien",code:"cz",alpha3:"cze", eu:true},
    {id:788,label:"Tunesien",code:"tn",alpha3:"tun"},
    {id:792,label:"Türkei",code:"tr",alpha3:"tur"},
    {id:795,label:"Turkmenistan",code:"tm",alpha3:"tkm"},
    {id:796,label:"Turks- und Caicosinseln",code:"tc",alpha3:"tca"},
    {id:798,label:"Tuvalu",code:"tv",alpha3:"tuv"},
    {id:800,label:"Uganda",code:"ug",alpha3:"uga"},
    {id:804,label:"Ukraine",code:"ua",alpha3:"ukr"},
    {id:348,label:"Ungarn",code:"hu",alpha3:"hun", eu:true},
    {id:581,label:"United States Minor Outlying Islands",code:"um",alpha3:"umi"},
    {id:858,label:"Uruguay",code:"uy",alpha3:"ury"},
    {id:860,label:"Usbekistan",code:"uz",alpha3:"uzb"},
    {id:548,label:"Vanuatu",code:"vu",alpha3:"vut"},
    {id:336,label:"Vatikanstadt",code:"va",alpha3:"vat"},
    {id:862,label:"Venezuela",code:"ve",alpha3:"ven"},
    {id:784,label:"Vereinigte Arabische Emirate",code:"ae",alpha3:"are"},
    {id:840,label:"Vereinigte Staaten",code:"us",alpha3:"usa"},
    {id:826,label:"Vereinigtes Königreich",code:"gb",alpha3:"gbr"},
    {id:704,label:"Vietnam",code:"vn",alpha3:"vnm"},
    {id:876,label:"Wallis und Futuna",code:"wf",alpha3:"wlf"},
    {id:162,label:"Weihnachtsinsel",code:"cx",alpha3:"cxr"},
    {id:732,label:"Westsahara",code:"eh",alpha3:"esh"},
    {id:140,label:"Zentralafrikanische Republik",code:"cf",alpha3:"caf"},
    {id:196,label:"Zypern",code:"cy",alpha3:"cyp", eu:true},
    {id:9999,label:"Deutsche Demokratische Republik (DDR)",code:"DDDE",alpha3:"DDDE", eu:true, de:true},
    {id:9999,label:"Tschechoslowakei",code:"CSHH",alpha3:"CSHH", eu:true},
    {id:9999,label:"Serbien und Montenegro",code:"CSXX",alpha3:"CSXX"},
    {id:9999,label:"Frankreich Metropolitan",code:"FXFR",alpha3:"FXFR", eu:true},
    {id:9999,label:"Sowjetunion",code:"SUHH",alpha3:"SUHH"},
    {id:9999,label:"Südjemen",code:"YDYE",alpha3:"YDYE"},
    {id:9999,label:"Jugoslawien",code:"YUCS",alpha3:"YUCS"}
];

const euLaender = () => {
    let rarr = [];
    laender.map(
        (obj) => {
            if (
                obj.hasOwnProperty("eu")
                && obj.eu === true
            ) {
                rarr.push(obj)
            }
        }
    )
    return rarr;
}

export default Laenderliste;